<template>
  <div v-click-outside="closeSidebar" class="sidebar">
    <div class="sidebar__close-btn" @click="closeSidebar">
      <i class="el-icon-close" />
    </div>
    <div class="sidebar__inner stack-lg">
      <account />
      <c-nav />
      <contacts />
      <div v-if="accData.freeAccessExpireDate" class="negative-margin">
        <pay-info :expire-date="accData.freeAccessExpireDate" />
      </div>
    </div>
  </div>
</template>

<script>
  import cNav from '@/components/sidebar/Nav'
  import Contacts from '@/components/sidebar/Contacts'
  import Account from '@/components/sidebar/Account'
  import PayInfo from '@/components/sidebar/PayInfo'
  import clickOutside from '@/directives/click-outside'

  export default {
    name: 'Sidebar',

    components: {
      cNav,
      Contacts,
      Account,
      PayInfo
    },

    directives: {
      clickOutside
    },

    computed: {
      accData() {
        return this.$store.state.user.accInfo || {}
      }
    },

    watch: {
      '$route' () {
        this.closeSidebar()
      }
    },

    methods: {
      closeSidebar() {
        document.body.classList.remove('sidebar-open')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .sidebar {
    background: #fff;
    box-shadow: $box-shadow-md;
    border-radius: $border-radius-md;
    font-size: $font-size-sm;
    line-height: $line-height-md;
  }
  .sidebar__inner {
    padding: 32px 24px 44px;
    @media (min-width: $viewport-sm) {
      padding-bottom: 24px;
    }
  }
  .sidebar__close-btn {
    display: inline-block;
    position: absolute;
    top: 0;
    right: 0;
    padding: 12px;
    font-size: 20px;
    cursor: pointer;
    &:hover {
      color: $primary-color;
    }
    @media (min-width: $viewport-sm) {
      display: none;
    }
  }
  .negative-margin {
    margin-left: -24px;
    margin-right: -24px;
    margin-bottom: -24px;
  }
</style>
